import { AddNewController, EditController } from "../../list-management/scripts/list-management.controllers";
import { DeliverablesEditControllerConfig, DeliverableParentExtended, DeliverableChildExtended } from "./deliverables-tracker.objects";
import {DeliverablesTable} from "./deliverables-tracker.table";
import { Section, SectionField } from "../../list-management/scripts/list-management.form-sections";
import { JsonItem, UserRequestExtended, UpdateGroupRequest, PickListItem, AppUserExtended, AppUserGroupCommittee, UpdateUserRequest, AppUserRedacted } from "../../list-management/scripts/list-management.objects";
import { getDisplayDate } from "../../../shared/scripts/date-functions"
import _ from "lodash";


export class EditDeliverablesController {
    // Config variables
    submitRoute: string;
    modalIdTarget: string;
    isAdmin: boolean;
    isChild: boolean;
    tableVarName: string;
    parentTable: DeliverablesTable;

    // Const Varaibles
    id: string;
    title: string;
    sections: Section[];
    displayPropertyName: string;
    
    editController: EditController;

    constructor(config: DeliverablesEditControllerConfig, parent: DeliverablesTable) {
        this.id = "deliverables-tracker-parent-edit-controller";
        this.title = "Edit Deliverables";
        this.submitRoute = config.submitRoute;
        this.modalIdTarget = config.modalIdTarget;
        this.isChild = config.isChild;
        this.isAdmin = config.isAdmin;
        this.tableVarName = config.tableVarName;
        this.parentTable = parent;

        if (this.isChild) {
            this.displayPropertyName = "DeliverableChild.Description";
        }
        else {
            this.displayPropertyName = "DeliverableParent.Description";
        }

        // Allow Admins to changed Planned Start/End Dates
        let plannedDateSections: SectionField[] = [
            //new SectionField("edit-parent-planned-start", "Planned Start Date", "date-input-readonly", "DeliverableParent.PlannedStartDate", false),
            //new SectionField("edit-parent-planned-end", "Planned End Date", "date-input-readonly", "DeliverableParent.PlannedEndDate", false),
            new SectionField("edit-parent-planned-start", "Planned Start Date", "date-input", "DeliverableParent.PlannedStartDate", true),
            new SectionField("edit-parent-planned-end", "Planned End Date", "date-input", "DeliverableParent.PlannedEndDate", true),
        ]
        if (this.isAdmin) {
            plannedDateSections = [
                new SectionField("edit-parent-planned-start", "Planned Start Date", "date-input", "DeliverableParent.PlannedStartDate", true),
                new SectionField("edit-parent-planned-end", "Planned End Date", "date-input", "DeliverableParent.PlannedEndDate", true),
            ]
        }

        if (this.isChild) {
            this.sections = [
                new Section("edit-deliverable-child-overview", "Overview",
                    [
                        new SectionField("edit-child-category-overview", "Category", "dropdown-readonly", "DeliverableChild.CategoryId", false, "pl-deliverable-category"),
                        new SectionField("edit-child-subcategory", "Subcategory", "deliverable-subcategory-dropdown", "DeliverableChild.SubcategoryIds", true, "", "", [["edit-child-category-overview"]], ["pl-subcategory-vaccine", "pl-subcategory-antibody", "pl-subcategory-knowledge", "pl-subcategory-coord"]),
                        new SectionField("edit-child-description", "Description", "input-lg", "DeliverableChild.Description", true),
                        new SectionField("edit-child-responsible-person", "Responsible Person", "dropdown-pl-search", "DeliverableChild.ResponsiblePersonId", true, "pl-users", "Search and select the person responsible for this deliverable")
                    ], "", "", false
                ),
                new Section("edit-deliverable-child-center-core-project", "Affiliation",
                    [
                        new SectionField("edit-child-center-core-project", "Affiliation", "center-core-project-selection", "", true, "", "", [["DeliverableChild.CenterId", "DeliverableChild.CoreId", "DeliverableChild.ProjectId"]], ["pl-all-centers", "pl-all-cores", "pl-all-projects"])
                    ]
                ),
                new Section("edit-deliverable-child-stage", "Stage",
                    [
                        new SectionField("edit-child-category-stage", "Category", "dropdown-readonly", "DeliverableChild.CategoryId", false, "pl-deliverable-category"),
                        new SectionField("edit-child-stage", "Stage", "deliverable-stage-dropdown", "DeliverableChild.StageId", true, "", "", [["edit-child-category-stage"]], ["pl-stage-vaccine", "pl-stage-antibody", "pl-stage-knowledge", "pl-stage-coord"]),
                    ], "", "", false
                ),
            ]
        }
        else {
            this.sections = [
                new Section("edit-deliverable-parent-overview", "Overview",
                    [
                        new SectionField("edit-parent-center", "Center", "dropdown-readonly", "DeliverableParent.CenterId", false, "pl-center"),
                        new SectionField("edit-parent-category", "Category", "dropdown-readonly", "DeliverableParent.CategoryId", false, "pl-deliverable-category"),
                        new SectionField("edit-parent-description", "Description", "input-lg", "DeliverableParent.Description", true),
                        new SectionField("edit-parent-trl", "Technology Readiness Level (TRL)", "deliverable-trl-dropdown", "DeliverableParent.TrlTagId", false, "pl-trl-tag", "", [["edit-parent-category"]])
                    ], "", "", false
                ),
                new Section("edit-deliverable-parent-timeline", "Timeline",
                    [
                        ...plannedDateSections,
                        new SectionField("edit-parent-actual-start", "Actual Start Date", "date-input", "DeliverableParent.ActualStartDate", false),
                        new SectionField("edit-parent-actual-end", "Actual End Date", "date-input", "DeliverableParent.ActualEndDate", false),
                    ], "", "", false
                ),
                new Section("edit-deliverable-parent-virus", "Virus Focus",
                    [
                        new SectionField("edit-parent-prototype-viruses", "Prototype Viruses", "pathogen-focus-selection-no-family", "DeliverableParent.PrototypeVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("edit-parent-test-viruses", "Test Case Viruses", "pathogen-focus-selection-no-family", "DeliverableParent.TestVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("edit-parent-virus-targets", "Virus Targets", "multi-dropdown-pl-search", "DeliverableParent.TargetIds", false, "pl-virus-target")
                    ], "", "", false, true
                )
            ]
        }

        this.editController = new EditController(this.id, this.title, "", this.sections, this.modalIdTarget, this.displayPropertyName);
    }

    initialize(pickLists: JsonItem[], selectedItems: any[], selectedSectionId: string): void {
        this.editController.initialize(pickLists, selectedItems, selectedSectionId);

        // Update Modal Footer Button
        let modalContentTarget = $(`#${this.modalIdTarget}`);
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveEditParentModal()">Save & Close</button><span class="error-msg ml-5" id="request-footer-error"></span>`;
        if (this.isChild) {
            htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveEditChildModal()">Save & Close</button><span class="error-msg ml-5" id="request-footer-error"></span>`;
        }
        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    async save(): Promise<any> {
        if (this.editController.selectedSection.fields.some(field => field.specialCaseEntity != undefined)) {
            this.editController.updateChangeLog();
        }

        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(this.editController.updatedItems) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            this.showSaved(false);
            $("#edit-item-content").addClass("d-none");
            $("#request-item-saving").removeClass("d-none");
        }
        else {
            $("#edit-item-content").removeClass("d-none");
            $("#request-item-saving").addClass("d-none");
        }
    }

    showSaved(isSaved: boolean) {
        if (isSaved) {
            $("#request-save-complete-block").removeClass("d-none");
            $("#request-save-in-progress-block").addClass("d-none");
        }
        else {
            $("#request-save-complete-block").addClass("d-none");
            $("#request-save-in-progress-block").removeClass("d-none");
        }
    }

    validateChanged(): boolean {
        let notChangedMessage = "";

        this.editController.selectedSection.fields.forEach(field => {
            if (!field.checkChanged()) {
                notChangedMessage = "Please update the deliverable information."
            }
        });

        let errorMsgTarget = $("#request-footer-error")
        errorMsgTarget.text(notChangedMessage);

        if (notChangedMessage == "") {
            return true;
        }
        else {
            return false;
        }
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $("#deliverable-filter-tabs").find(".active").first();
        return selectedTab.prop("id");
    }

    async saveEditModal(): Promise<void> {
        // if it isn't valid, don't save
        let isValid = this.editController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.editController.showLoading(true);
            
            let shouldFilter: boolean = true; // Maintain Filters by default; If its a new item => remove filters so new item always visible
            if (this.isChild) {
                let editedItems: DeliverableChildExtended[] = this.editController.updatedItems;
                if (editedItems.some(item => item.DeliverableChild.Id == 0)) {
                    shouldFilter = false;
                }
            }
            else {
                let editedItems: DeliverableParentExtended[] = this.editController.updatedItems;
                if (editedItems.some(item => item.DeliverableParent.Id == 0)) {
                    shouldFilter = false;
                }
            }

            // Get Current Filter Options
            let selectedTab: string = this.getSelectedFilterTabId();
            let currentFilterOptions: any[][] = this.parentTable.filterTabs.map(tab => {
                return tab.getSelectedValues();
            });

            // Get Table Sort 
            let sortOrder: any[] = this.parentTable.getCurrentTableSort();

            // saves changes to DB (returns updated items)
            let result: any[] = await this.save();

            // reinitialze
            await this.parentTable.initialize()

            // Show Saved
            this.editController.showSaved(true);

            // Set Current Filter Options
            if (shouldFilter) {
                for (let i = 0; i < currentFilterOptions.length; i++) {
                    let tabVals = currentFilterOptions[i];
                    this.parentTable.filterTabs[i].setSelectedValues(tabVals);
                }
            }       
            $(`#${selectedTab}`).trigger("click");

            // Set Table Sort
            this.parentTable.setCurrentTableSort(sortOrder);

            // Scroll to Edited Item
            if (this.isChild) {
                let editedItems: DeliverableChildExtended[] = this.editController.updatedItems;
                if (editedItems.length > 0) {
                    let targetItem = editedItems[0];
                    this.parentTable.scrollToParent(targetItem.DeliverableChild.ParentId);
                }
            }
            else {
                let editedItems: DeliverableParentExtended[] = this.editController.updatedItems;
                if (editedItems.length > 0) {
                    let targetItem = editedItems[0];
                    this.parentTable.scrollToParent(targetItem.DeliverableParent.Id);
                }
            }

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.modalIdTarget}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.editController.showLoading(false);
                    this.editController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}

export class AddDeliverablesController {
    // Config variables
    submitRoute: string;
    modalIdTarget: string;
    isAdmin: boolean;
    isChild: boolean;
    tableVarName: string;
    parentTable: DeliverablesTable;

    // Const Varaibles
    id: string;
    title: string;
    sections: Section[];
    displayPropertyName: string;

    addController: AddNewController;

    constructor(config: DeliverablesEditControllerConfig, parent: DeliverablesTable) {
        this.id = "deliverables-tracker-parent-add-controller";      
        this.submitRoute = config.submitRoute;
        this.modalIdTarget = config.modalIdTarget;
        this.isChild = config.isChild;
        this.isAdmin = config.isAdmin;
        this.tableVarName = config.tableVarName;
        this.parentTable = parent;

        if (this.isChild) {
            this.displayPropertyName = "DeliverableChild.Description";
            this.title = "Add Child Deliverable";
        }
        else {
            this.displayPropertyName = "DeliverableParent.Description";
            this.title = "Add Deliverable";
        }

        // Limit Parent Deliverable Center if not admin
        let parentCenterSectionField = new SectionField("add-parent-center", "Center", "dropdown-pl", "DeliverableParent.CenterId", true, "pl-center-limited");
        if (this.isAdmin) {
            parentCenterSectionField = new SectionField("add-parent-center", "Center", "dropdown-pl", "DeliverableParent.CenterId", true, "pl-center");
        }

        if (this.isChild) {
            this.sections = [
                new Section("add-deliverable-child-overview", "Overview",
                    [
                        new SectionField("add-child-category-overview", "Category", "dropdown-readonly", "DeliverableChild.CategoryId", true, "pl-deliverable-category"),
                        new SectionField("add-child-subcategory", "Subcategory", "deliverable-subcategory-dropdown-new", "DeliverableChild.SubcategoryIds", true, "", "", [["add-child-category-overview"]], ["pl-subcategory-vaccine", "pl-subcategory-antibody", "pl-subcategory-knowledge", "pl-subcategory-coord"]),
                        new SectionField("add-child-description", "Description", "input-lg", "DeliverableChild.Description", true),
                        new SectionField("add-child-stage", "Stage", "deliverable-stage-dropdown-new", "DeliverableChild.StageId", true, "", "", [["add-child-category-overview"]], ["pl-stage-vaccine", "pl-stage-antibody", "pl-stage-knowledge", "pl-stage-coord"]),
                    ], "", "", false
                ),
                new Section("add-deliverable-child-affiliation", "Affiliation",
                    [
                        new SectionField("add-child-center-core-project", "Affiliation", "center-core-project-selection-new", "", true, "", "", [["DeliverableChild.CenterId", "DeliverableChild.CoreId", "DeliverableChild.ProjectId"]], ["pl-all-centers", "pl-all-cores", "pl-all-projects"])
                    ], "", "", false
                ),
                new Section("add-deliverable-child-responsible-person", "Responsible Person",
                    [
                        new SectionField("add-child-responsible-person", "Responsible Person", "dropdown-pl-search", "DeliverableChild.ResponsiblePersonId", true, "pl-users", "Search and select the person responsible for this deliverable")
                    ], "", "", false
                )
            ]
        }
        else {
            this.sections = [
                new Section("add-deliverable-parent-overview", "Overview",
                    [
                        parentCenterSectionField,
                        new SectionField("add-parent-category", "Category", "dropdown-pl", "DeliverableParent.CategoryId", true, "pl-deliverable-category"),
                        new SectionField("add-parent-description", "Description", "input-lg", "DeliverableParent.Description", true),
                        new SectionField("add-parent-trl", "Technology Readiness Level (TRL)", "deliverable-trl-dropdown-new", "DeliverableParent.TrlTagId", true, "pl-trl-tag", "", [["add-parent-category"]])
                    ], "", "", false
                ),
                new Section("add-deliverable-parent-timeline", "Timeline",
                    [
                        new SectionField("add-parent-planned-start", "Planned Start Date", "date-input", "DeliverableParent.PlannedStartDate", true),
                        new SectionField("add-parent-planned-end", "Planned End Date", "date-input", "DeliverableParent.PlannedEndDate", true),
                        new SectionField("add-parent-actual-start", "Actual Start Date", "date-input", "DeliverableParent.ActualStartDate", false),
                        new SectionField("add-parent-actual-end", "Actual End Date", "date-input", "DeliverableParent.ActualEndDate", false),
                    ], "", "", false
                ),
                new Section("add-deliverable-parent-virus", "Virus Focus",
                    [
                        new SectionField("add-parent-prototype-viruses", "Prototype Viruses", "pathogen-focus-selection-no-family", "DeliverableParent.PrototypeVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("add-parent-test-viruses", "Test Case Viruses", "pathogen-focus-selection-no-family", "DeliverableParent.TestVirusIds", false, "all-viruses", "", undefined, ["pl-virus-family"]),
                        new SectionField("add-parent-virus-targets", "Virus Targets", "multi-dropdown-pl-search", "DeliverableParent.TargetIds", false, "pl-virus-target")
                    ], "", "", false, true
                )
            ]
        }

        this.addController = new AddNewController(this.id, this.title, "", this.sections, this.modalIdTarget);
    }

    initialize(pickLists: JsonItem[], defaultItem: any, description: string = ""): void {

        this.addController.initialize(pickLists, defaultItem);

        let modalContentTarget = $(`#${this.modalIdTarget}`);
        // Update Modal Title
        let htmlTitleContent = `
            <div>${this.title}</div>
        `
        if (description != "") {
            htmlTitleContent = `
                <div>${this.title}</div>
                <div class="font-size14 font-italic font-weight-500">${description}</div>
            `
        }
        modalContentTarget.find(".modal-title").empty().html(htmlTitleContent);

        // Update Modal Footer Button
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveAddParentModal()">Add New Deliverable!</button><span class="error-msg ml-5" id="request-footer-error"></span>`;
        if (this.isChild) {
            htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveAddChildModal()">Add New Child Deliverable!</button><span class="error-msg ml-5" id="request-footer-error"></span>`;
        }
        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    async save(): Promise<any> {
        let updatedItem = this.addController.getCurrentItem();
        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify([updatedItem]) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean): void {
        this.addController.showLoading(isLoading);
    }

    showSaved(isSaved: boolean): void {
        this.addController.showSaved(isSaved);
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $("#deliverable-filter-tabs").find(".active").first();
        return selectedTab.prop("id");
    }

    async saveAddModal(): Promise<void> {
        // if it isn't valid, don't save
        let isValid = this.addController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.addController.showLoading(true);

            // Get Current Filter Options
            let selectedTab: string = this.getSelectedFilterTabId();
            /*let currentFilterOptions: any[][] = this.parentTable.filterTabs.map(tab => {
                return tab.getSelectedValues();
            });*/

            // Get Current Sort
            let sortOrder: any[] = this.parentTable.getCurrentTableSort();

            // saves changes to DB (returns updated items)
            let result: any[] = await this.save();

            // reinitialze
            await this.parentTable.initialize()

            // Show Saved
            this.addController.showSaved(true);

            // Set Current Filter Options
            /*for (let i = 0; i < currentFilterOptions.length; i++) {
                let tabVals = currentFilterOptions[i];
                this.parentTable.filterTabs[i].setSelectedValues(tabVals);
            }*/
            $(`#${selectedTab}`).trigger("click");

            // Set Table Sort
            this.parentTable.setCurrentTableSort(sortOrder);

            // Scroll to New Item
            if (this.isChild) {
                let newItem: DeliverableChildExtended = this.addController.getCurrentItem();

                if (newItem) {
                    let parentId = newItem.DeliverableChild.ParentId;
                    this.parentTable.scrollToParent(parentId);
                }
            }
            else {
                this.parentTable.scrollToParent();
            }

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.modalIdTarget}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.addController.showLoading(false);
                    this.addController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}

export class DeleteDeliverableController {
    // Config variables
    submitRoute: string;
    childSubmitRoute: string;
    modalId: string;
    tableVarName: string;
    parentTable: DeliverablesTable;

    targetDeliverable: DeliverableParentExtended;
    targetChildDeliverable: DeliverableChildExtended;
    isChild: boolean = false;

    constructor(parent: DeliverablesTable) {
        this.submitRoute = "/secure/list-management/list-management?handler=DeleteParentDeliverables"
        this.childSubmitRoute = "/secure/list-management/list-management?handler=DeleteChildDeliverables"
        this.modalId = "delete-deliverable-modal";
        this.tableVarName = parent.tableVarName;
        this.parentTable = parent;
    }

    initialize(parentDeliverable: DeliverableParentExtended) {
        this.isChild = false;
        this.targetDeliverable = parentDeliverable;

        let modalContentTarget = $(`#${this.modalId}`);

        // Update Content
        let htmlTitleContent = `
            <div class="font-weight-600 font-size20 mb-2">Confirm Delete Deliverable</div>
            <div class="font-weight-500 font-size16 mb-3">${parentDeliverable.DeliverableParent.Description}</div>
            <div>This will permanently delete this parent deliverable, its associated child deliverables, comments, and attachments.</div>
        `

        modalContentTarget.find(".modal-body").empty().html(htmlTitleContent);

        // Update Modal Footer Button
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.deleteDeliverable()">Delete Deliverable</button>`;

        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    initializeChild(childDeliverable: DeliverableChildExtended) {
        this.isChild = true;
        this.targetChildDeliverable = childDeliverable;

        let modalContentTarget = $(`#${this.modalId}`);
        // Update Content
        let htmlTitleContent = `
            <div class="font-weight-600 font-size20 mb-2">Confirm Delete Deliverable</div>
            <div class="font-weight-500 font-size16 mb-3">${childDeliverable.DeliverableChild.Description}</div>
            <div>This will permanently delete this child deliverable, comments, and attachments.</div>
        `

        modalContentTarget.find(".modal-body").empty().html(htmlTitleContent);

        // Update Modal Footer Button
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.deleteDeliverable()">Delete Deliverable</button>`;

        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    showLoading(isLoading: boolean): void {
        let formContent = $(`#${this.modalId}`).find("#delete-item-content");
        let savingContent = $(`#${this.modalId}`).find("#delete-item-saving");

        if (isLoading) {
            this.showSaved(false);
            formContent.addClass("d-none");
            savingContent.removeClass("d-none");
        }
        else {
            formContent.removeClass("d-none");
            savingContent.addClass("d-none");
        }
    }

    showSaved(isSaved: boolean): void {
        let saveCompleteBlock = $(`#${this.modalId}`).find("#delete-save-complete-block");
        let savingProgressBlock = $(`#${this.modalId}`).find("#delete-save-in-progress-block");

        if (isSaved) {
            saveCompleteBlock.removeClass("d-none");
            savingProgressBlock.addClass("d-none");
        }
        else {
            saveCompleteBlock.addClass("d-none");
            savingProgressBlock.removeClass("d-none");
        }
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $("#deliverable-filter-tabs").find(".active").first();
        return selectedTab.prop("id");
    }

    async deleteDeliverable() {
        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify([this.targetDeliverable]) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async deleteChildDeliverable() {
        let result: any;
        try {
            result = await $.ajax(this.childSubmitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify([this.targetChildDeliverable]) }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async deleteDeliverableModal() {
        this.showLoading(true);

        // Get Current Filter Options
        let selectedTab: string = this.getSelectedFilterTabId();
        let currentFilterOptions: any[][] = this.parentTable.filterTabs.map(tab => {
            return tab.getSelectedValues();
        });

        // Get table sort
        let sortOrder: any[] = this.parentTable.getCurrentTableSort();

        // Delete Deliverable
        if (this.isChild) {
            await this.deleteChildDeliverable();
        }
        else {
            await this.deleteDeliverable();
        }

        // reinitialze
        await this.parentTable.initialize()

        this.showSaved(true);

        // Set Current Filter Options
        for (let i = 0; i < currentFilterOptions.length; i++) {
            let tabVals = currentFilterOptions[i];
            this.parentTable.filterTabs[i].setSelectedValues(tabVals);
        }
        $(`#${selectedTab}`).trigger("click");

        // Set table sort
        this.parentTable.setCurrentTableSort(sortOrder);

        // Scroll to Parent
        if (this.isChild) {
            let parentId = this.targetChildDeliverable.DeliverableChild.ParentId;
            this.parentTable.scrollToParent(parentId);
        }

        // hide loading/close modal
        setTimeout(() => {
            $(`#${this.modalId}`).modal('hide');

            // Don't hide information until after modal finishes hiding
            setTimeout(() => {
                this.showLoading(false);
                this.showSaved(false);
            }, 1000)
        }, 1000)
    }
}
